"use client";

import { Suspense } from "react";
import SignInFormV2 from "@/components/common/forms/SignInFormV2";
import Loader from "@/components/common/LoaderComponent";

export default function SignInPage() {
  return (
    <Suspense
      fallback={
        <div className="min-h-[85vh] flex items-center justify-center bg-[#2A1E1E]">
          <Loader label="Loading Sign In..." size="lg" />
        </div>
      }
    >
      <SignInFormV2 />
    </Suspense>
  );
}
